var _path, _path2, _g, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg3User(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8865 12.1465C17.5185 12.1465 17.1975 11.8755 17.1445 11.5005C17.0875 11.0895 17.3725 10.7105 17.7835 10.6535C18.8235 10.5075 19.6085 9.60551 19.6105 8.55351C19.6105 7.51051 18.8625 6.62851 17.8315 6.45951C17.4235 6.39251 17.1465 6.00651 17.2135 5.59751C17.2815 5.18851 17.6645 4.91451 18.0755 4.97951C19.8335 5.26851 21.1105 6.77251 21.1105 8.55551C21.1065 10.3505 19.7655 11.8905 17.9905 12.1395C17.9555 12.1445 17.9205 12.1465 17.8865 12.1465Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_1621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 14,
    width: 5,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.978 14.0017H22.772V18.5313H18.978V14.0017Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_1621)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8613 18.5313C20.5593 18.5313 20.2743 18.3473 20.1603 18.0483C20.0123 17.6613 20.2073 17.2273 20.5943 17.0803C21.2723 16.8223 21.2723 16.5373 21.2723 16.4003C21.2723 15.9623 20.7153 15.6563 19.6173 15.4923C19.2083 15.4303 18.9253 15.0493 18.9863 14.6383C19.0473 14.2283 19.4273 13.9553 19.8403 14.0083C22.2633 14.3713 22.7723 15.5093 22.7723 16.4003C22.7723 16.9443 22.5583 17.9373 21.1283 18.4823C21.0403 18.5153 20.9503 18.5313 20.8613 18.5313Z",
    fill: "black"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8867 15.9141C9.51073 15.9141 6.67773 16.2061 6.67773 17.5961C6.67773 18.9971 9.51073 19.2911 11.8867 19.2911C14.2627 19.2911 17.0947 19.0001 17.0947 17.6131C17.0947 16.2091 14.2627 15.9141 11.8867 15.9141ZM11.8867 20.7911C10.2277 20.7911 5.17773 20.7911 5.17773 17.5961C5.17773 14.4141 10.2277 14.4141 11.8867 14.4141C13.5457 14.4141 18.5947 14.4141 18.5947 17.6131C18.5947 20.7911 13.7217 20.7911 11.8867 20.7911Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8864 5.5C10.1944 5.5 8.8184 6.877 8.8184 8.569C8.8154 9.389 9.1294 10.156 9.7044 10.735C10.2794 11.314 11.0454 11.635 11.8614 11.638L11.8864 12.388V11.638C13.5784 11.638 14.9554 10.262 14.9554 8.569C14.9554 6.877 13.5784 5.5 11.8864 5.5ZM11.8864 13.138H11.8594C10.6394 13.134 9.4964 12.656 8.6404 11.792C7.7824 10.929 7.3134 9.783 7.3184 8.566C7.3184 6.05 9.3674 4 11.8864 4C14.4064 4 16.4554 6.05 16.4554 8.569C16.4554 11.088 14.4064 13.138 11.8864 13.138Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8856 12.1465C5.8516 12.1465 5.8166 12.1445 5.7816 12.1395C4.0066 11.8905 2.6666 10.3505 2.6626 8.55745C2.6626 6.77245 3.9396 5.26845 5.6976 4.97945C6.1186 4.91345 6.4916 5.19045 6.5596 5.59745C6.6266 6.00645 6.3496 6.39245 5.9416 6.45945C4.9106 6.62845 4.1626 7.51045 4.1626 8.55545C4.1646 9.60545 4.9496 10.5085 5.9886 10.6535C6.3996 10.7105 6.6846 11.0894 6.6276 11.5005C6.5746 11.8755 6.2536 12.1465 5.8856 12.1465Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.912 18.5313C2.823 18.5313 2.733 18.5153 2.645 18.4823C1.214 17.9363 1 16.9433 1 16.4003C1 15.5103 1.509 14.3713 3.933 14.0083C4.346 13.9563 4.724 14.2283 4.786 14.6383C4.847 15.0493 4.564 15.4303 4.155 15.4923C3.057 15.6563 2.5 15.9623 2.5 16.4003C2.5 16.5373 2.5 16.8213 3.179 17.0803C3.566 17.2273 3.761 17.6613 3.613 18.0483C3.499 18.3473 3.214 18.5313 2.912 18.5313Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3User);
export default __webpack_public_path__ + "static/media/3User.9d20438d4f4c690604f78a6bf7c12d88.svg";
export { ForwardRef as ReactComponent };